import DispensaryCard, {
  DispensaryCardProps,
} from "components/botanic/DispensaryCard/DispensaryCard";
import PickupReadinessLabel from "components/botanic/DispensaryCard/PickupReadinessLabel";

export const PickupReadinessDispensaryCard: React.FC<DispensaryCardProps> = ({
  dispensaryId,
  onClick,
  ctaOnClick,
  ...otherProps
}) => {
  return (
    <DispensaryCard
      dispensaryId={dispensaryId}
      renderReadinessLabel={() => (
        <PickupReadinessLabel dispensaryId={dispensaryId} />
      )}
      {...otherProps}
      onClick={(e) => {
        onClick && onClick(e);
      }}
      ctaOnClick={(e) => {
        ctaOnClick && ctaOnClick(e);
      }}
    />
  );
};

export default PickupReadinessDispensaryCard;
